<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <router-link
                class="btn btn-sm btn-outline-info"
                :to="{ name: 'pos-cuponera' }"
              >
                <i class="fas fa-angle-double-left"></i>
                Atras
              </router-link>
              <h5 class="form-header">
                <h5 v-if="!current.id">Agregar nuevo cupón</h5>
                <h5 v-if="current.id">
                  Cuponera<span class="text-success"> # {{ current.id }}</span
                  >&nbsp;
                  <span
                    class="badge"
                    v-bind:class="{
                      'badge-success': current.estatus == true,
                      'badge-danger': current.estatus == false,
                    }"
                    ><div v-if="current.estatus == true">ACTIVO</div>
                    <div v-if="current.estatus == false">INACTIVO</div></span
                  >
                </h5>

                &nbsp;
              </h5>
              <div class="row">
                <div class="col-3">
                  <label>Fecha inicio</label>
                  <input
                    :disabled="current.estado == 'B'"
                    type="date"
                    class="form-control"
                    v-model="current.fecha_inicio"
                  />
                  <small
                    class="text-danger"
                    v-if="current.errors && current.errors.fecha_inicio"
                    >{{ current.errors.fecha_inicio }}</small
                  >
                </div>
                <div class="col-3">
                  <label>Fecha fin</label>
                  <input
                    :disabled="current.estado == 'B'"
                    type="date"
                    class="form-control"
                    v-model="current.fecha_fin"
                  />
                  <small
                    class="text-danger"
                    v-if="current.errors && current.errors.fecha_fin"
                    >{{ current.errors.fecha_fin }}</small
                  >
                  <br />
                </div>
                <div class="col-6">
                  <label>Nombre cupón</label>
                  <input
                    :disabled="current.estado == 'B'"
                    type="text"
                    v-model="current.nombre"
                    class="form-control"
                  />
                  <small
                    class="text-danger"
                    v-if="current.errors && current.errors.nombre"
                    >{{ current.errors.nombre }}</small
                  >
                  <br />
                </div>

                <div class="col-3">
                  <label>Cantidad de cupones</label>
                  <input
                    :disabled="current.estado == 'B'"
                    type="text"
                    class="form-control"
                    v-model="current.cant_cupones"
                  />
                  <small
                    class="text-danger"
                    v-if="current.errors && current.errors.cant_cupones"
                    >{{ current.errors.cant_cupones }}</small
                  >
                  <br />
                </div>
                <div class="col-3">
                  <label>Cantidad maxima de cupones por fact.</label>
                  <input
                    :disabled="current.estado == 'B'"
                    type="text"
                    class="form-control"
                    v-model="current.cant_maxima_cupones"
                  />
                  <small
                    class="text-danger"
                    v-if="current.errors && current.errors.cant_maxima_cupones"
                    >{{ current.errors.cant_maxima_cupones }}</small
                  >
                  <br />
                </div>
                <div class="col-3">
                  <label>Valor minimo de factura</label>
                  <input
                    :disabled="current.estado == 'B'"
                    type="text"
                    class="form-control"
                    v-model="current.minimo_de_factura"
                  />

                  <small
                    class="text-danger"
                    v-if="current.errors && current.errors.minimo_de_factura"
                    >{{ current.errors.minimo_de_factura }}</small
                  >
                  <br />
                </div>
                <div class="col-3">
                  <label>Por cada</label>
                  <input
                    :disabled="current.estado == 'B'"
                    type="text"
                    class="form-control"
                    v-model="current.por_cada"
                  />

                  <small
                    class="text-danger"
                    v-if="current.errors && current.errors.minimo_de_factura"
                    >{{ current.errors.minimo_de_factura }}</small
                  >
                  <br />
                </div>
                <div class="col-3">
                  <h6 class="font-weight-bold">Estatus de cupón: &nbsp;</h6>
                  <input
                    :disabled="current.estatus == false"
                    class="form-control"
                    v-model="current.estatus"
                    type="checkbox"
                    @change="inactivarCupon()"
                  />
                </div>
                <div class="col-3">
                  <h6 class="font-weight-bold">
                    ¿Limitar listado por detalle de producto? &nbsp;
                  </h6>
                  <input
                    :disabled="current.estatus == false"
                    class="form-control"
                    v-model="current.limitar_listado"
                    type="checkbox"
                    @change="CambiarTipoListado()"
                  />
                </div>
              </div>
              <CuponeraModelAddComponent
                @refresh="refreshCurrent()"
                :current="current"
              />
              <br />
              <h6>Detalle de productos participantes</h6>
              <div class="invoice-table" v-if="current.id != null">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th style="width: 300px !important">SKU</th>
                      <th>Nombre</th>
                      <th>Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(detalle, indexDetalle) in current.cuponerasku_set"
                      :key="indexDetalle"
                    >
                      <td>{{ detalle.producto.sku }}</td>
                      <td>{{ detalle.producto.nombre }}</td>
                      <td>
                        <button
                          @click="eliminarDetalle(detalle)"
                          :disabled="
                            current.estatus == false ||
                            current.limitar_listado == false
                          "
                          class="btn btn-danger btn-sm"
                        >
                          <i class="far fa-trash-alt"></i> Eliminar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!-------------------- END - Basic Table -------------------->
              </div>
              <div class="form-buttons-w">
                <button
                  class="btn btn-md btn-success"
                  v-if="current.estado == 'A'"
                  type="button"
                  @click="guardar()"
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import CuponeraModelAddComponent from "@/components/pos/cuponera/CuponeraModelAddComponent";

export default {
  components: {
    CuponeraModelAddComponent,
  },
  data() {
    return {
      current: {
        estado: "A",
        estatus: true,
        tienda: "",
        fecha: "",
        errors: [],
        usuario: "",
        fecha_inicio: "",
        fecha_fin: "",
        tipos_liq: "",
        producto: "",
      },
      detalle: {},
      tipos_liq: [],
      tiendas: [],
      currentDetalle: {},
      tiendas: "",
    };
  },
  computed: {},
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
  },
  methods: {
    CambiarTipoListado() {
      let self = this;
      DynamicService.postAction(
        "cat",
        "cuponera",
        self.current.id,
        "cambiar_tipo_listado"
      )
        .then((response) => {
          Notifications.alert.success(
            "Cambiar tipo listado",
            "Realizado correctamente"
          );
        })
        .catch((errors) => {
          self.current.errors = errors.response.data;
        });
    },
    eliminarDetalle(det) {
      DynamicService.postAction(
        "cat",
        "cuponera",
        this.current.id,
        "eliminar_detalle",
        {
          id: det.id,
        }
      )
        .then((response) => {
          Notifications.alert.success(
            "Eliminar Detalle",
            "Realizado existosamente"
          );
          this.refreshCurrent();
        })
        .catch((errors) => {
          Notifications.alert.error(
            "eliminar detalle",
            errors.response.data.detail
          );
        });
    },
    inactivarCupon() {
      let self = this;
      swal({
        title: "Inactivar el cupón",
        text: "Se realiza esta acción ya no podra volver a activarlo",
        icon: "warning",
        buttons: ["No", "Si"],
        dangerMode: false,
      }).then((result) => {
        if (result) {
          self.guardar();
        } else {
          self.current.estatus = true;
        }
      });
    },
    guardar() {
      this.detalle = this.current;
      this.detalle.fecha_inicio = this.dateSaveFormatter(
        this.detalle.fecha_inicio
      );
      this.detalle.fecha_fin = this.dateSaveFormatter(this.detalle.fecha_fin);
      DynamicService.save("cat", "cuponera", this.detalle)
        .then((response) => {
          if (this.$route.params.id) {
            Notifications.alert.success(
              "Modificar información",
              "Realizado correctamente"
            );
          } else {
            Notifications.alert.success(
              "Agregar nueva cuponera",
              "Agregado existosamente"
            );
            this.$router.push({
              name: "pos-cuponera-editar",
              params: { id: response.data.id },
            });
          }
          this.refreshCurrent();
        })
        .catch((errors) => {
          this.current.errors = errors.response.data;
        });
    },
    customFormatterInverted(date) {
      if (date == null) {
        return "";
      }
      var d = date.split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];
      return moment(str_d).format("YYYY-MM-DD");
    },
    dateSaveFormatter(date) {
      if (date == null) {
        return "";
      }
      return moment(date).format("DD/MM/YYYY");
    },
    imprimir() {
      let self = this;
      OrdenCompraService.pdf(self.current.id)
        .then((response) => {
          window.open(response.data.output);
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById("cat", "cuponera", this.$route.params.id).then(
        (response) => {
          self.current = response.data;
          if (self.current.id) {
            self.current.estado = "B";
          }
          self.current.fecha_inicio = this.customFormatterInverted(
            self.current.fecha_inicio
          );
          self.current.fecha_fin = this.customFormatterInverted(
            self.current.fecha_fin
          );
        }
      );
    },
  },
};
</script>
